// Copyright ©️ 2026 eVolve MEP, LLC

import type { ShipmentPaginated } from '@evolvemep/api-ts';

import { EntityStatusBadge } from 'components/Mantine/EntityStatusBadge';
import { SelectableCard } from 'components/Mantine/Navigation/SelectableCard';

type Props = {
  shipment: ShipmentPaginated;
};

export const SelectableShipmentCard = ({ shipment }: Props) => (
  <SelectableCard
    from="Shipping Orders"
    to={`/shipping-orders/${shipment.shipmentId}`}
    title={shipment.name}
    description={shipment.identifier}
    rightSection={
      <EntityStatusBadge
        customStatusEntityName="Shipment"
        stateName={shipment.shipmentStateName}
        statusId={shipment.shipmentStatusId}
      />
    }
  />
);
